// @flow
import React, { Component, Fragment } from 'react';  
import PropTypes from 'prop-types';
import { Desktop, UntilTablet } from '../../../../utils/responsive';

import style from './CustomBanner.scss';
 
import type { Node } from 'react';

type Position =  'left' | 'right';

type Props = { 
  direction?: 'normal' | 'reverse';  
  background: string;
  left?: Node; 
  right?: Node;
  sideImage?: {
    image: string;
    position: Position;
  };
  button?: Node;
  positionButton?: Position;
};

export default class CustomBanner extends Component<Props> {
  render() {  
    const {
      direction = 'normal', 
      background,  
      sideImage,
      left,
      right,
      button,
      positionButton = 'left'
    } = this.props;
 
    const sideImageElement =
      <img src={sideImage && sideImage.image} className={style.sideImage}/>;

    return ( 
      <div className={style.bannerWrap} style={{background}}>
         <div className={`${style.dualWrap} ${direction === 'reverse' ? style.reverseWrap : style.columnWrap}`}>
            <div className={style.leftWrap}>
              {sideImage && sideImage.position === 'left' && sideImageElement} 
              {left && (
                <div className={style.contentWrapStyle}>
                  {left}
                  <UntilTablet>
                    {direction === 'normal' && button}
                  </UntilTablet>
                  <Desktop>
                    {positionButton === 'left' && button}
                  </Desktop>
                </div>
              )}
            </div>
            <div className={style.rightWrap}> 
              {sideImage && sideImage.position === 'right' && sideImageElement} 
              {right && (
                <div className={style.contentWrapStyle}>
                  {right} 
                  <UntilTablet>
                    {direction === 'reverse' && button}
                  </UntilTablet>
                  <Desktop>
                    {positionButton === 'right' && button}
                  </Desktop>
                </div>
              )} 
            </div>
        </div>
      </div>
    );
  }
}


CustomBanner.propTypes = { 
  direction: PropTypes.string,
  left: PropTypes.node,
  right: PropTypes.node,
  background: PropTypes.string.isRequired,
  sideImage: PropTypes.object,
  button: PropTypes.node,
  positionButton: PropTypes.string
};
 



// WEBPACK FOOTER //
// ./src/modules/home/elements/CustomBanner/CustomBanner.jsx